import React from "react";
import { FormTextInput } from "@jsq/ds/forms";
import { SimpleFormRow } from "../../../../../common/components/Form/Layout/SimpleFormRow";
import { stackedSm } from "../../../../../common/themes/spacing_styles_vanilla.css";
import { AccountDetailsInputFields, WireExtraFieldInputFields } from "./constants";
import { type BaseExtraInputFieldsProps, type ExtraInputFieldsProps } from "./types";

const BaseExtraInputFields: React.FC<BaseExtraInputFieldsProps> = ({
  fieldType,
  label,
  placeholderGenerator,
}) => {
  return (
    <>
      {Object.values(WireExtraFieldInputFields).map((fieldNo, idx) => {
        return (
          <SimpleFormRow key={`${fieldType}.${fieldNo}`} className={stackedSm}>
            <FormTextInput
              isFullWidth
              label={idx === 0 ? label : undefined} // only show a label for the first field of each set
              placeholder={placeholderGenerator(idx)}
              name={`${fieldType}.${fieldNo}`}
            />
          </SimpleFormRow>
        );
      })}
    </>
  );
};

export const ExtraInputFields: React.FC<ExtraInputFieldsProps> = ({ fieldType }) => {
  const labelText =
    fieldType === AccountDetailsInputFields.OBI
      ? "OBI (Originator to Beneficiary Information)"
      : "BBI (Bank to Bank Information)";

  const placeholderGenerator = (fieldIndex: number) => {
    if (fieldType === AccountDetailsInputFields.OBI && fieldIndex < 2) {
      return `E.g. For Further Credit ${fieldIndex === 0 ? "name" : "account number"}`;
    }
    return "";
  };

  return (
    <BaseExtraInputFields
      fieldType={fieldType}
      label={labelText}
      placeholderGenerator={placeholderGenerator}
    />
  );
};
